import { API, APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'
import _set from 'lodash/set'
import { TrinoConnector } from './TrinoConnector'

class Consumer extends APIObject {
  constructor (options) {
    super('DM', options)
    this._id = this._id || ''
    this.display_name = this.display_name || ''
    this.name = this.name || ''
    this.description = this.description || ''
    this.consumer_type = this.consumer_type || ''
    this.tags = this.tags || {}
    this.parameters = this.parameters || {}
    this.configuration = this.configuration || {}
    this.configuration.logo = this.configuration.logo || ''
  }

  _filter (object) {
    return _omit(super._filter(object), [
      '_id',
      'created_at',
      'updated_at',
      'created_by',
      'updated_by',
      'uid',
      'name',
      'consumer_type'
    ])
  }

  async create () {
    return super.create({
      method: 'POST',
      url: `v4/consumer/${this.consumer_type}`
    })
  }

  async save () {
    return super.save({
      method: 'PUT',
      url: `v4/consumer/${this.consumer_type}`
    })
  }

  async remove () {
    return this.request({
      method: 'DELETE',
      url: `v4/consumer/${this.consumer_type}`
    })
  }
}

class Consumers extends API {
  probeAi (parameters) {
    return this.request({
      method: 'POST',
      url: 'v4/consumer/ai/models',
      data: { parameters }
    })
  }

  // Listed by the backend with the stored key: the page never holds it
  listAiModels () {
    return this.request({
      method: 'GET',
      url: 'v4/consumer/ai/models'
    })
  }

  updateAi (parameters) {
    return this.request({
      method: 'PUT',
      url: 'v4/consumer/ai',
      data: { parameters }
    })
  }

  list () {
    return this.request({
      method: 'GET',
      url: 'v4/consumer'
    }).then(data => {
      return data.map(consumer => {
        if (consumer.consumer_type === 'trino') return new TrinoConnector(consumer)
        return new Consumer(consumer)
      })
    })
  }

  new (queryString) {
    const item = {}
    for (const key in queryString) {
      _set(item, key, queryString[key])
    }
    return new Consumer(item)
  }
}

export default Consumers
export { Consumer, Consumers }
